import UsersPage from './users';

export default UsersPage;
